export default {
    serverURL: '/api',
    allowUseFakeData: false,
}